import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 10" {...props}>
    <path
      fill="#17181A"
      fillRule="evenodd"
      d="M.924 10V.662h4.914c1.778 0 2.688 1.134 2.688 2.38 0 1.176-.728 1.96-1.61 2.142.994.154 1.792 1.12 1.792 2.296 0 1.4-.938 2.52-2.716 2.52H.924zm4.48-5.6c.672 0 1.092-.42 1.092-1.008 0-.588-.42-1.022-1.092-1.022H2.912V4.4h2.492zm.07 3.878c.756 0 1.204-.406 1.204-1.078 0-.588-.42-1.092-1.204-1.092H2.912v2.17h2.562z"
    />
  </svg>
);
const Memo = memo(SvgBold);
export default Memo;
